import { render, staticRenderFns } from "./RemoveAgentsModal.vue?vue&type=template&id=9d2aa1c6"
import script from "./RemoveAgentsModal.vue?vue&type=script&lang=js"
export * from "./RemoveAgentsModal.vue?vue&type=script&lang=js"
import style0 from "./RemoveAgentsModal.vue?vue&type=style&index=0&id=9d2aa1c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports